import { useState } from "react";
import { useNavigate } from "react-router-dom";
import httpService from "../services/httpService";
import { useAuthStore } from "../store/store";

/**
 * Custom hook for handling user logout
 * @param {Object} options - Configuration options
 * @param {string} options.redirectTo - URL to redirect to after logout (default: '/login')
 * @param {Function} options.onSuccess - Callback function called after successful logout
 * @param {Function} options.onError - Callback function called if logout fails
 * @returns {Object} { logout, isLoading, error }
 */
export const useLogout = (options = {}) => {
    const {
        redirectTo = '/login',
        onSuccess,
        onError
    } = options;

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const { clearToken, clearUser } = useAuthStore();

    const logout = async () => {
        setIsLoading(true);
        setError(null);

        try {
            await httpService.post('logout');
            clearToken();
            clearUser();

            if (onSuccess) {
                onSuccess();
            }

            if (redirectTo) {
                navigate(redirectTo);
            }
        } catch (err) {
            console.error('Logout error:', err);
            setError(err);

            if (onError) {
                onError(err);
            }
        } finally {
            setIsLoading(false);
        }
    };

    return { logout, isLoading, error };
};